var _g, _g2, _circle, _circle2, _circle3, _circle4, _g3, _rect, _rect2, _rect3, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructorCardSkeleton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 266,
    viewBox: "0 0 285 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1764:121080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3194 18.11C15.3194 15.4642 17.4642 13.3194 20.1099 13.3194H200.236C202.881 13.3194 205.026 15.4642 205.026 18.1099V222.508C205.026 225.154 202.881 227.298 200.236 227.298H20.1099C17.4642 227.298 15.3194 225.154 15.3194 222.508V18.11Z",
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 0.638743
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 27.7754,
    y: 77.1367,
    width: 151.382,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 27.7754,
    y: 91.1875,
    width: 61.9581,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 27.7754,
    y: 139.617,
    width: 61.9581,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.7977,
    cy: 51.5858,
    rx: 16.0224,
    ry: 15.9686,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 168.215H205.346V168.854H15V168.215Z",
    fill: "#F1F3F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1764:121080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0791 39.4928C80.0791 36.847 82.224 34.7022 84.8697 34.7022H264.995C267.641 34.7022 269.786 36.847 269.786 39.4928V243.891C269.786 246.536 267.641 248.681 264.995 248.681H84.8697C82.2239 248.681 80.0791 246.536 80.0791 243.891V39.4928Z",
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 0.638743
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 92.5352,
    y: 98.5195,
    width: 151.382,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 92.5352,
    y: 112.57,
    width: 61.9581,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 92.5352,
    y: 161,
    width: 61.9581,
    height: 7.02618,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.558,
    cy: 72.9686,
    rx: 16.0224,
    ry: 15.9686,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7598 189.598H270.105V190.236H79.7598V189.598Z",
    fill: "#F1F3F4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.388,
    cy: 65.9701,
    r: 13.9701,
    fill: "#F9F9F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.73,
    cy: 65.9702,
    r: 0.970149,
    stroke: "#7F7F7F",
    strokeWidth: 1.16418
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.388,
    cy: 65.9702,
    r: 0.970149,
    stroke: "#7F7F7F",
    strokeWidth: 1.16418
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.044,
    cy: 65.9702,
    r: 0.970149,
    stroke: "#7F7F7F",
    strokeWidth: 1.16418
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1764:121080)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.388,
    y: 82.6576,
    width: 145.134,
    height: 124.955,
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 0.776119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.019 107.688H132.497L129.378 99.9294H127.759L124.641 107.688H126.054L126.792 105.786H130.291L131.019 107.688ZM128.542 101.32H128.574L129.857 104.667H127.238L128.542 101.32ZM137.118 107.688H138.487V99.6904H137.096V103.07C136.835 102.515 136.205 102.037 135.346 102.037C133.901 102.037 132.913 103.222 132.913 104.928C132.913 106.644 133.901 107.818 135.346 107.818C136.183 107.818 136.846 107.362 137.118 106.807V107.688ZM137.128 105.025C137.128 106.101 136.618 106.797 135.738 106.797C134.836 106.797 134.314 106.069 134.314 104.928C134.314 103.798 134.836 103.059 135.738 103.059C136.618 103.059 137.128 103.754 137.128 104.83V105.025ZM143.895 107.688H145.265V99.6904H143.874V103.07C143.613 102.515 142.983 102.037 142.124 102.037C140.679 102.037 139.69 103.222 139.69 104.928C139.69 106.644 140.679 107.818 142.124 107.818C142.961 107.818 143.624 107.362 143.895 106.807V107.688ZM143.906 105.025C143.906 106.101 143.396 106.797 142.516 106.797C141.614 106.797 141.092 106.069 141.092 104.928C141.092 103.798 141.614 103.059 142.516 103.059C143.396 103.059 143.906 103.754 143.906 104.83V105.025ZM151.944 106.547C151.64 106.634 151.423 106.655 151.216 106.655C150.749 106.655 150.499 106.481 150.499 105.96V103.167H151.825V102.168H150.51V100.788H149.13V102.168H148.369V103.167H149.13V106.177C149.13 107.285 149.695 107.774 150.847 107.774C151.184 107.774 151.51 107.742 151.944 107.611V106.547ZM158.266 104.928C158.266 103.146 157.104 102.037 155.474 102.037C153.844 102.037 152.681 103.146 152.681 104.928C152.681 106.72 153.844 107.818 155.474 107.818C157.104 107.818 158.266 106.72 158.266 104.928ZM154.072 104.928C154.072 103.776 154.572 103.07 155.474 103.07C156.365 103.07 156.875 103.776 156.875 104.928C156.875 106.09 156.365 106.786 155.474 106.786C154.572 106.786 154.072 106.09 154.072 104.928ZM161.195 106.014C161.315 107.22 162.347 107.818 163.781 107.818C165.096 107.818 166.107 107.122 166.107 106.069C166.107 105.156 165.563 104.623 164.596 104.46L163.521 104.276C162.956 104.178 162.673 104.037 162.673 103.656C162.673 103.276 163.053 103.015 163.64 103.015C164.249 103.015 164.672 103.298 164.727 103.732H165.998C165.878 102.668 165.064 102.037 163.629 102.037C162.347 102.037 161.391 102.754 161.391 103.798C161.391 104.786 162.065 105.21 162.977 105.373L163.955 105.547C164.564 105.656 164.803 105.819 164.803 106.166C164.803 106.612 164.346 106.851 163.76 106.851C163.162 106.851 162.586 106.59 162.521 106.014H161.195ZM168.738 103.102V99.6904H167.347V107.688H168.738V104.689C168.738 103.58 169.281 103.135 169.976 103.135C170.704 103.135 171.085 103.591 171.085 104.471V107.688H172.476V104.145C172.476 102.82 171.715 102.037 170.455 102.037C169.618 102.037 169.009 102.461 168.738 103.102ZM179.202 104.928C179.202 103.146 178.04 102.037 176.41 102.037C174.78 102.037 173.617 103.146 173.617 104.928C173.617 106.72 174.78 107.818 176.41 107.818C178.04 107.818 179.202 106.72 179.202 104.928ZM175.008 104.928C175.008 103.776 175.508 103.07 176.41 103.07C177.301 103.07 177.811 103.776 177.811 104.928C177.811 106.09 177.301 106.786 176.41 106.786C175.508 106.786 175.008 106.09 175.008 104.928ZM183.881 102.113C183.762 102.081 183.609 102.07 183.468 102.07C182.675 102.07 182.034 102.548 181.773 103.406V102.168H180.404V107.688H181.795V105.134C181.795 103.939 182.501 103.352 183.349 103.352C183.523 103.352 183.718 103.363 183.881 103.396V102.113ZM188.004 106.547C187.7 106.634 187.482 106.655 187.276 106.655C186.809 106.655 186.559 106.481 186.559 105.96V103.167H187.884V102.168H186.57V100.788H185.19V102.168H184.429V103.167H185.19V106.177C185.19 107.285 185.755 107.774 186.906 107.774C187.243 107.774 187.569 107.742 188.004 107.611V106.547ZM190.586 107.688V99.6904H189.195V107.688H190.586ZM192.131 101.233H193.609V99.8751H192.131V101.233ZM192.175 107.688H193.565V102.168H192.175V107.688ZM194.708 106.014C194.828 107.22 195.86 107.818 197.294 107.818C198.609 107.818 199.62 107.122 199.62 106.069C199.62 105.156 199.076 104.623 198.109 104.46L197.034 104.276C196.469 104.178 196.186 104.037 196.186 103.656C196.186 103.276 196.566 103.015 197.153 103.015C197.762 103.015 198.185 103.298 198.24 103.732H199.511C199.391 102.668 198.576 102.037 197.142 102.037C195.86 102.037 194.904 102.754 194.904 103.798C194.904 104.786 195.578 105.21 196.49 105.373L197.468 105.547C198.077 105.656 198.316 105.819 198.316 106.166C198.316 106.612 197.859 106.851 197.273 106.851C196.675 106.851 196.099 106.59 196.034 106.014H194.708ZM203.783 106.547C203.479 106.634 203.261 106.655 203.055 106.655C202.588 106.655 202.338 106.481 202.338 105.96V103.167H203.663V102.168H202.349V100.788H200.969V102.168H200.208V103.167H200.969V106.177C200.969 107.285 201.534 107.774 202.685 107.774C203.022 107.774 203.348 107.742 203.783 107.611V106.547Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.775 124.18H254.134",
    stroke: "#E9E9E9",
    strokeWidth: 0.776119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.775 166.09H254.134",
    stroke: "#E9E9E9",
    strokeWidth: 0.776119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.891 147.251C125.032 148.957 126.456 149.728 128.303 149.728C130.02 149.728 131.313 148.794 131.313 147.381C131.313 146.132 130.552 145.501 129.281 145.262L127.781 144.969C126.945 144.806 126.542 144.599 126.542 143.958C126.542 143.274 127.129 142.785 128.064 142.785C129.031 142.785 129.704 143.209 129.802 143.969H131.16C131.008 142.513 129.9 141.709 128.053 141.709C126.358 141.709 125.141 142.665 125.141 144.045C125.141 145.404 126.064 145.947 127.205 146.153L128.629 146.414C129.563 146.588 129.9 146.903 129.9 147.468C129.9 148.25 129.183 148.663 128.259 148.663C127.292 148.663 126.38 148.305 126.282 147.251H124.891ZM137.461 147.881H136.179C135.994 148.413 135.603 148.707 134.973 148.707C134.115 148.707 133.615 148.153 133.528 147.175H137.494V146.729C137.494 145.262 136.668 143.948 134.94 143.948C133.387 143.948 132.18 145.045 132.18 146.849C132.18 148.652 133.365 149.728 134.973 149.728C136.233 149.728 137.222 149.065 137.461 147.881ZM134.94 144.98C135.777 144.98 136.168 145.588 136.168 146.273H133.571C133.723 145.425 134.212 144.98 134.94 144.98ZM140.071 144.078H138.702V149.598H140.093V146.599C140.093 145.49 140.636 145.045 141.331 145.045C142.059 145.045 142.44 145.501 142.44 146.381V149.598H143.831V146.055C143.831 144.73 143.07 143.948 141.81 143.948C140.973 143.948 140.332 144.382 140.071 145.012V144.078ZM149.177 149.598H150.546V141.601H149.155V144.98C148.895 144.426 148.265 143.948 147.406 143.948C145.961 143.948 144.972 145.132 144.972 146.838C144.972 148.555 145.961 149.728 147.406 149.728C148.243 149.728 148.906 149.272 149.177 148.718V149.598ZM149.188 146.936C149.188 148.011 148.677 148.707 147.797 148.707C146.895 148.707 146.374 147.979 146.374 146.838C146.374 145.708 146.895 144.969 147.797 144.969C148.677 144.969 149.188 145.664 149.188 146.74V146.936ZM157.671 149.598H159.008C158.921 149.152 158.899 148.728 158.899 148.218V146.088C158.899 144.654 158.041 143.948 156.541 143.948C155.183 143.948 154.26 144.643 154.14 145.827H155.477C155.52 145.317 155.889 144.98 156.498 144.98C157.128 144.98 157.541 145.306 157.541 145.979V146.24L155.889 146.425C154.77 146.555 153.901 147.012 153.901 148.12C153.901 149.12 154.683 149.717 155.759 149.717C156.639 149.717 157.335 149.359 157.595 148.728C157.595 149 157.617 149.293 157.671 149.598ZM156.139 148.75C155.585 148.75 155.281 148.478 155.281 148.044C155.281 147.468 155.727 147.338 156.313 147.262L157.541 147.12V147.457C157.541 148.326 156.857 148.75 156.139 148.75ZM167.376 145.023C167.105 144.371 166.594 143.948 165.671 143.948C164.877 143.948 164.236 144.371 163.976 145.012V144.078H162.606V149.598H163.997V146.588C163.997 145.512 164.508 145.045 165.182 145.045C165.866 145.045 166.192 145.48 166.192 146.36V149.598H167.583V146.588C167.583 145.512 168.104 145.045 168.767 145.045C169.452 145.045 169.778 145.48 169.778 146.36V149.598H171.179V146.055C171.179 144.741 170.506 143.948 169.234 143.948C168.42 143.948 167.724 144.36 167.376 145.023ZM177.606 147.881H176.324C176.139 148.413 175.748 148.707 175.118 148.707C174.259 148.707 173.76 148.153 173.673 147.175H177.639V146.729C177.639 145.262 176.813 143.948 175.085 143.948C173.531 143.948 172.325 145.045 172.325 146.849C172.325 148.652 173.51 149.728 175.118 149.728C176.378 149.728 177.367 149.065 177.606 147.881ZM175.085 144.98C175.922 144.98 176.313 145.588 176.313 146.273H173.716C173.868 145.425 174.357 144.98 175.085 144.98ZM178.454 147.924C178.574 149.13 179.606 149.728 181.04 149.728C182.355 149.728 183.366 149.033 183.366 147.979C183.366 147.066 182.822 146.534 181.855 146.371L180.78 146.186C180.215 146.088 179.932 145.947 179.932 145.566C179.932 145.186 180.312 144.925 180.899 144.925C181.508 144.925 181.931 145.208 181.986 145.643H183.257C183.137 144.578 182.323 143.948 180.888 143.948C179.606 143.948 178.65 144.665 178.65 145.708C178.65 146.697 179.324 147.12 180.236 147.283L181.214 147.457C181.823 147.566 182.062 147.729 182.062 148.076C182.062 148.522 181.605 148.761 181.019 148.761C180.421 148.761 179.845 148.5 179.78 147.924H178.454ZM184.161 147.924C184.28 149.13 185.312 149.728 186.747 149.728C188.061 149.728 189.072 149.033 189.072 147.979C189.072 147.066 188.529 146.534 187.561 146.371L186.486 146.186C185.921 146.088 185.638 145.947 185.638 145.566C185.638 145.186 186.019 144.925 186.605 144.925C187.214 144.925 187.638 145.208 187.692 145.643H188.963C188.844 144.578 188.029 143.948 186.594 143.948C185.312 143.948 184.356 144.665 184.356 145.708C184.356 146.697 185.03 147.12 185.942 147.283L186.92 147.457C187.529 147.566 187.768 147.729 187.768 148.076C187.768 148.522 187.312 148.761 186.725 148.761C186.127 148.761 185.551 148.5 185.486 147.924H184.161ZM193.681 149.598H195.017C194.93 149.152 194.908 148.728 194.908 148.218V146.088C194.908 144.654 194.05 143.948 192.551 143.948C191.192 143.948 190.269 144.643 190.149 145.827H191.486C191.529 145.317 191.899 144.98 192.507 144.98C193.137 144.98 193.55 145.306 193.55 145.979V146.24L191.899 146.425C190.779 146.555 189.91 147.012 189.91 148.12C189.91 149.12 190.692 149.717 191.768 149.717C192.648 149.717 193.344 149.359 193.604 148.728C193.604 149 193.626 149.293 193.681 149.598ZM192.148 148.75C191.594 148.75 191.29 148.478 191.29 148.044C191.29 147.468 191.736 147.338 192.322 147.262L193.55 147.12V147.457C193.55 148.326 192.866 148.75 192.148 148.75ZM200.246 149.228C200.246 150.228 199.713 150.684 198.833 150.684C198.192 150.684 197.714 150.489 197.562 149.945H196.182C196.388 151.043 197.345 151.662 198.833 151.662C200.474 151.662 201.637 150.858 201.637 149.054V144.078H200.268V144.98C200.007 144.447 199.377 143.948 198.496 143.948C197.04 143.948 196.063 145.078 196.063 146.697C196.063 148.348 197.04 149.456 198.496 149.456C199.377 149.456 199.985 148.978 200.246 148.446V149.228ZM200.3 146.805C200.3 147.794 199.713 148.435 198.866 148.435C197.975 148.435 197.453 147.74 197.453 146.697C197.453 145.643 197.975 144.958 198.866 144.958C199.713 144.958 200.3 145.599 200.3 146.577V146.805ZM208.132 147.881H206.85C206.665 148.413 206.274 148.707 205.643 148.707C204.785 148.707 204.285 148.153 204.198 147.175H208.164V146.729C208.164 145.262 207.339 143.948 205.611 143.948C204.057 143.948 202.851 145.045 202.851 146.849C202.851 148.652 204.035 149.728 205.643 149.728C206.904 149.728 207.893 149.065 208.132 147.881ZM205.611 144.98C206.448 144.98 206.839 145.588 206.839 146.273H204.242C204.394 145.425 204.883 144.98 205.611 144.98Z",
    fill: "#333333"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.699,
    y: 83,
    width: 144.5,
    height: 41,
    fill: "#F1F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 97,
    width: 100,
    height: 12,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 140,
    width: 100,
    height: 12,
    fill: "#7F7F7F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 181,
    width: 116,
    height: 12,
    fill: "#7F7F7F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1764:121080",
    x: 0.596121,
    y: 0.516638,
    width: 219.153,
    height: 243.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20194
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1764:121080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1764:121080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1764:121080",
    x: 65.3559,
    y: 21.8995,
    width: 219.153,
    height: 243.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20194
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1764:121080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1764:121080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1764:121080",
    x: 101.239,
    y: 76.0606,
    width: 161.433,
    height: 141.253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.8806
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1764:121080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1764:121080",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorCardSkeleton);
export default __webpack_public_path__ + "static/media/instructor-card-skeleton.74afcb20.svg";
export { ForwardRef as ReactComponent };